import { TJsonQuery } from '../../../packages/JsonQuery';
import { TLocation } from 'shared/types/location';
import { ISearchMeta } from 'shared/types/searchMeta';

export const FILTERS_UPDATED_EVENT = 'filters:updated';

interface IFiltersUpdatedEventDetail {
  jsonQuery: TJsonQuery;
  searchMeta: ISearchMeta;
  location: TLocation;
}

export const dispatchFiltersUpdatedEvent = (detail: IFiltersUpdatedEventDetail) => {
  dispatchEvent(
    new CustomEvent<IFiltersUpdatedEventDetail>(FILTERS_UPDATED_EVENT, {
      detail,
    }),
  );
};
